(() => {
  if (customElements.get('bfq-faq')) return;
  customElements.define('bfq-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-faq-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));
      if (!this.tabs.length) return;
      const list = this.querySelector('.wpfaq__questions');
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', this.querySelector('.wpfaq__heading')?.textContent.trim() || 'FAQ');
      list.setAttribute('aria-orientation', 'vertical');
      this.tabs.forEach((tab, index) => {
        const panel = this.panels[index];
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.select(index);
          if (matchMedia('(max-width: 900px)').matches) {
            panel.focus({ preventScroll: true });
            panel.scrollIntoView({ block: 'start', behavior: 'instant' });
          }
        }, options);
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key === ' ') { event.preventDefault(); tab.click(); return; }
          else return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }, options);
      });
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const index = this.tabs.findIndex(tab => tab.dataset.faqTab === event.detail?.blockId);
        if (index !== -1) this.select(index);
      }, options);
      const current = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
      this.select(current < 0 ? 0 : current);
      this.setAttribute('data-ready', '');
    }
    select(index) {
      this.tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[position].hidden = !selected;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
